export { registeredWrapperMapper } from './registeredWrapperMapper';
